import { render, staticRenderFns } from "./GameFinished.vue?vue&type=template&id=46c62b9c"
import script from "./GameFinished.vue?vue&type=script&lang=js"
export * from "./GameFinished.vue?vue&type=script&lang=js"
import style0 from "./GameFinished.vue?vue&type=style&index=0&id=46c62b9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports